<template>
<div id="permisos" >
    <div>
        <v-breadcrumbs :items="breadcrumbs" >
            <v-icon slot="divider" >forward</v-icon>
        </v-breadcrumbs>
    </div>
    <v-container fluid fill-height>
        <v-layout align-center justify-center>
            <v-flex xs12>
                <base-material-card color="primary" icon="library_books" title="Administrar Tipos de Permiso" class="elevation-1 px-5 py-3" >
                    <v-card-actions>
                        <v-spacer></v-spacer>

                        <v-speed-dial direction="left" open-on-hover>
                            <template v-slot:activator>
                                <v-btn x-small fab dark color="primary" >
                                    <v-icon>reorder</v-icon>
                                </v-btn>
                            </template>
                            <exportar-excel v-tippy style="cursor: pointer" :data="datafiltered" :exportFields="permisos.camposexcel" name="Permisos.xlsx" >
                                <v-btn fab x-small dark color="success" title="Exportar" v-tippy>
                                    <v-icon dark>get_app</v-icon>
                                </v-btn>
                            </exportar-excel>
                            <upload-excel-component :on-success="handleSuccess" :before-upload="beforeUpload" />
                            <exportar-excel :data="permisos.camposLayout" :exportFields="permisos.encabezadoLayout" name="Layout Tipo Permisos.xlsx" >
                                <v-btn fab x-small dark x-small color="purple darken-2" title="Descargar Layout" v-tippy>
                                    <v-icon dark>receipt</v-icon>
                                </v-btn>
                            </exportar-excel>
                        </v-speed-dial>

                        <v-btn fab dark x-small color="secondary" slot="activator" @click.native="openModal(1)" title="Agregar Registro" v-tippy>
                            <v-icon dark>add</v-icon>
                        </v-btn>

                        <v-dialog v-model="modal" max-width="60%" style=" z-index: 400 !important;" >
                            <v-card>
                                <v-card-title>
                                    <v-card class="primary white--text titulomodal" >
                                        <v-icon class="white--text" >{{
                        update ? "edit" : "add"
                      }}</v-icon>&nbsp;
                                        <span class="subheading" >
                                            <strong>{{ update ? "Actualizar" : "Nuevo" }} Tipo de
                                                Permiso</strong>
                                        </span>
                                    </v-card>
                                    <v-spacer></v-spacer>
                                    <v-btn icon @click.native="modal = false" class="close_modal" >
                                        <v-icon class="white--text" >cancel</v-icon>
                                    </v-btn>
                                </v-card-title>
                                <v-form ref="form" lazy-validation>
                                    <v-card-text>
                                        <v-container grid-list-md text-xs-center @keyup.enter="guardar()" >
                                            <v-layout row wrap>
                                                <v-flex s12 m12 l12>
                                                    <v-text-field name="clave" label="Clave" type="text" @input="model.clave = model.clave.toUpperCase()" v-model="model.clave" :rules="[rules.required]" maxlength="10" ></v-text-field>
                                                </v-flex>
                                            </v-layout>
                                            <v-layout row wrap>
                                                <v-flex s12 m12 l12>
                                                    <v-text-field name="descripcion" label="Descripción del Permiso" type="text" v-model="model.descripcion" :rules="[rules.required]" maxlength="250" ></v-text-field>
                                                </v-flex>
                                            </v-layout>
                                            <v-layout row wrap>
                                                <v-flex s12 m12 l12>
                                                    <v-text-field name="dependencia" label="Dependencia" type="text" v-model="model.dependencia" :rules="[rules.required]" maxlength="100" ></v-text-field>
                                                </v-flex>
                                            </v-layout>
                                        </v-container>
                                    </v-card-text>
                                </v-form>
                                <v-card-actions>
                                    <v-spacer></v-spacer>
                                    <v-btn @click.native="modal = false" >
                                        <v-icon>cancel</v-icon> Cancelar
                                    </v-btn>
                                    <v-btn color="success" :loading="loading" @click.native="guardar()" >
                                        <v-icon>done</v-icon>
                                        {{ update ? "Actualizar" : "Guardar" }}
                                    </v-btn>
                                </v-card-actions>
                            </v-card>
                        </v-dialog>
                    </v-card-actions>

                    <v-card-text>
                        <div id="datagrid" >

                            <v-client-table ref="vuetable" :data="permisos.items" :columns="columns" :options="options" class="elevation-2 pa-2" >
                                <template slot="noResults" >
                                    <v-alert :value="true" icon="info" color="info" >No se encontro ningun registro</v-alert>
                                </template>

                                <template slot="actions" slot-scope="props" >
                                    <v-speed-dial :id="props.row.id" direction="left" open-on-hover>
                                        <template v-slot:activator>
                                            <v-btn :id="props.row.id" x-small fab dark color="primary" >
                                                <v-icon>reorder</v-icon>
                                            </v-btn>
                                        </template>

                                        <v-btn x-small fab dark color="blue" @click.native="getRegistro(props.row.id_tipo_permiso)" title="Editar Registro" v-tippy>
                                            <v-icon>edit</v-icon>
                                        </v-btn>
                                        <v-btn x-small fab dark color="pink" @click.native="
                          deleteRegistro(props.row.id_tipo_permiso)
                        " title="Eliminar Registro" v-tippy>
                                            <v-icon>delete</v-icon>
                                        </v-btn>
                                    </v-speed-dial>
                                </template>
                            </v-client-table>
                        </div>
                    </v-card-text>
                </base-material-card>
            </v-flex>
        </v-layout>
    </v-container>
</div>
</template>

<script>
import axios from "axios";

export default {
    components: {},
    data: () => ({
        fab: false,
        name: "datagrid",
        importData: [],
        columns: ["clave", "descripcion", "dependencia", "actions"],
        show_loading: true,
        options: {
            filterable: ["clave", "descripcion", "dependencia"],

            sortable: ["clave", "descripcion", "dependencia"],

            headings: {
                clave: "Clave",
                descripcion: "Nombre",
                dependencia: "Dependencia",
                actions: "Operaciones"
            }
        },
        URL: "",
        show_loading: true,
        breadcrumbs: [{
                text: "Inicio",
                disabled: false,
                to: "/home"
            },
            {
                text: "Catálogos",
                disabled: true,
                to: ""
            },
            {
                text: "Tipos de Permisos",
                disabled: true,
                to: ""
            }
        ],
        loading: false,
        title: "",
        modal: false,
        update: false,
        pagination: {
            sortBy: "clave"
        },
        search: "",
        model: {
            id_tipo_permiso: 0,
            clave: "",
            descripcion: "",
            dependencia: ""
        },
        rules: {
            required: v => !!v || "Este campo es requerido"
        },
        permisos: {
            selected: [],
            camposexcel: {
                Clave: "clave",
                Descripción: "descripcion",
                Dependencia: "dependencia"
            },
            items: [0],
            //En el encabezado deben ser iguales los pares, respetando el nombre del campo definido en el modelo de la API
            encabezadoLayout: {
                clave: "clave",
                descripcion: "descripcion",
                dependencia: "dependencia"
            },
            //van vacíos para solo descargar layout con encabezados
            camposLayout: [{
                clave: "[Clave del Permiso]",
                descripcion: "[Descripción del Permiso]",
                dependencia: "[Dependencia]"
            }]
        }
    }),
    computed: {
        datafiltered() {
            if (this.$refs.vuetable != null) {
                return this.$refs.vuetable.allFilteredData;
            } else {
                return this.permisos.items;
            }

        },
    },
    methods: {
        openModal: function (type) {
            if (type === 1) {
                this.limpiarModel();
                this.title = "Nuevo Permiso";
                this.update = false;
            } else {
                this.title = "Actualizar Permiso";
                this.update = true;
            }
            this.modal = true;
        },

        limpiarModel: function () {
            for (var k in this.model) {
                this.model[k] = "";
            }
        },

        guardar() {
            const datos = this.model;

            if (!this.$refs.form.validate()) {
                //Alguna operación o mensaje
            } else {
                this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
                var metodo = "post";
                var urlCliente = this.URL;
                if (this.update == true) {
                    metodo = "put";
                    urlCliente += this.model.id_tipo_permiso + "/";
                }
                axios({
                        method: metodo,
                        url: urlCliente,
                        data: datos
                    })
                    .then(res => {
                        this.$swal({
                            type: "success",
                            title: "¡Operación Exitosa!",
                            text: "Los datos se guardaron correctamente",
                            footer: ""
                        });
                        this.cargar();
                        this.$root.$dialogLoader.hide();
                        this.modal = false;
                    })
                    .catch(error => {
                        this.$swal({
                            position: "center",
                            type: "error",
                            title: "¡Operación no Permitida!",
                            text: "Ocurrió un error al guardar los datos"
                            //showConfirmButton: false,
                        });
                        console.log(error);
                        this.cargar();
                        this.$root.$dialogLoader.hide();
                        this.modal = false;
                    });
            }
        },

        cargar: function () {
            axios
                .get(this.URL)
                .then(res => {
                    if (typeof res.data !== "undefined") {
                        this.permisos.items = res.data;
                        this.$root.$dialogLoader.hide();
                    }
                })
                .catch(err => {
                  
                    console.log(err);
                    this.$root.$dialogLoader.hide();
                });
        },

        getRegistro: function (id_registro) {
            axios
                .get(this.URL + id_registro + "/")
                .then(response => {
                    this.model = response.data;
                    this.openModal(2); //ACTUALIZAR
                })
                .catch(error => {
                    this.$swal({
                        type: "error",
                        title: "¡Operación no Permitida!",
                        text: "Ocurrió un error al obtener el registro",
                        footer: ""
                    });
                });
        }, //getRegistro

        deleteRegistro: function (id_registro) {
            this.$swal({
                type: "info",
                title: "Cuidado",
                text: "¿Está seguro de eliminar el registro?",
                footer: "",
                showCancelButton: true,
                cancelButtonColor: "#d33",
                confirmButtonColor: "#3085d6",
                confirmButtonText: "Aceptar",
                cancelButtonText: "Cancelar"
            }).then(result => {
                if (result.value)
                    axios
                    .delete(this.URL + id_registro + "/")
                    .then(response => {
                        this.cargar();
                        this.$swal({
                            type: "success",
                            title: "Operación Exitosa",
                            text: "El registro se eliminó correctamente.",
                            //position: 'bottom-end',
                            //timer: 3000,
                            //showConfirmButton: false,
                            footer: ""
                        });
                    })
                    .catch(error => {
                        this.$swal({
                            type: "error",
                            title: "¡Operación no Permitida!",
                            text: "Ocurrió un error al eliminar el registro",
                            footer: ""
                        });
                    });
            });
        },
        beforeUpload(file) {
            const isLt2M = file.size / 1024 / 1024 < 2;

            if (isLt2M) {
                return true;
            }
            this.$swal({
                type: "warning",
                title: "¡Operación no Permitida!",
                text: "El archivo no debe ser mayor a 2MB.",
                footer: ""
            });
            return false;
        },
        handleSuccess({
            results,
            header
        }) {
            for (var k in results) {
                results[k]["user_updated"] = this.$local_storage.get("email");
            }
            this.importData = results;
            this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');

            axios
                .post(this.URL + "importar_permisos/", this.importData)
                .then(() => {
                    this.$swal({
                        type: "success",
                        title: "¡Operación Exitosa!",
                        text: "Los datos se guardaron correctamente",
                        footer: ""
                    });
                })
                .catch(err => {
                    var errores = "";
                    if (typeof err.response.data != "undefined") {
                        for (var i = 0; i < err.response.data.length; i++) {
                            Object.keys(err.response.data[i]).forEach(function (key) {
                                errores +=
                                    "Fila " +
                                    (i + 2) +
                                    " => " +
                                    key +
                                    ": " +
                                    err.response.data[i][key];
                                errores += "<br>";
                            });
                        }
                    }
                    this.$swal({
                        type: "error",
                        title: "¡Operación no Permitida!",
                        text: "Verifique que los encabezados correspondan con el layout y que no existan registros duplicados.",
                        footer: errores
                    });
                })
                .then(() => {
                    this.cargar();
                    this.$root.$dialogLoader.hide();
                });
        }
    }, //methods
    created: function () {
        this.URL = this.$hostname + "catalogos/permisos/";
        this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
        this.cargar();
    }
};
</script>
